import { render, staticRenderFns } from "./TheAlert.vue?vue&type=template&id=49d39c04&scoped=true&"
import script from "./TheAlert.vue?vue&type=script&lang=ts&"
export * from "./TheAlert.vue?vue&type=script&lang=ts&"
import style0 from "./TheAlert.vue?vue&type=style&index=0&id=49d39c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d39c04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
